import { render, staticRenderFns } from "./part-penerima.vue?vue&type=template&id=200e3272&"
import script from "./part-penerima.vue?vue&type=script&lang=js&"
export * from "./part-penerima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports